<template>
  <div>
    <v-row class="mx-auto" justify="center">
      <v-col cols="12" class="pa-0">
        <h2 class="mt-5 text-center light-green--text">
          {{ $t("queue_table_panel.subjects_eligible_for_registration") }}
        </h2>
        <h3 class="mt-2 text-center light-green--text text--darken-4">
          {{ $t("queue_table_panel.details") }}
        </h3>
      </v-col>
      <v-col cols="12" lg="8" class="mb-0 pa-0">
        <v-simple-table dense class="mt-2">
          <template v-slot:default>
            <thead>
              <tr class="light-green white--text">
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.subject_id") }}
                </th>
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.subject_name") }}
                </th>
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.section") }}
                </th>
                <th class="text-center last-cell">
                  {{ $t("queue_table_panel.entitled_to") }}
                </th>
                <!-- <th
                  class="text-center last-cell"
                  v-if="change_period"
                >
                  {{ $t("queue_table_panel.waiver") }}
                </th> -->
              </tr>
            </thead>
            <tbody>
              <tr
                :class="
                  item.registering ? 'green lighten-2' : 'light-green lighten-4'
                "
                v-for="(item, index) in queue_granted_list"
                :key="index"
              >
                <td class="text-center">{{ item.subject_id }}</td>
                <td class="text-center">
                  <a class="subject-link" @click="openSubjectDialog(item.subject_id)">
                    {{ item.subject_ename }}
                  </a>
                </td>
                <td class="text-center">{{ item.section }}</td>
                <td class="text-center last-cell">
                  <span v-if="item.EXPIRE_TIMESTAMP">
                    {{
                      db_datetime_to_dayjs(item.EXPIRE_TIMESTAMP)
                        .locale(lang)
                        .format(`dddd D MMMM ${lang == "th" ? "BBBB" : "YYYY"} HH:mm:ss`)
                    }}
                  </span>
                </td>
                <!-- <td
                  class="text-center last-cell"
                  v-if="change_period"
                >
                  <v-btn
                    color="red"
                    dark
                    x-small
                    elevation="0"
                    @click="open_remove_queue_dialog(item)"
                  >{{ $t("queue_table_panel.waiver") }}</v-btn>
                </td> -->
              </tr>
              <tr
                v-if="!queue_granted_list || queue_granted_list.length === 0"
                class="light-green lighten-4"
              >
                <td class="last-cell text-center" colspan="5">
                  {{ $t("queue_table_panel.no_item") }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <!-- --------------------------------------------------------------- -->
    <queue-table
      :open_remove_queue_dialog="open_remove_queue_dialog"
      :queued_subject_list="queued_subject_list"
      :change_period="change_period"
      :level_id="level_id"
    ></queue-table>
    <!-- --------------------------------------------------------------- -->
    <div class="text-center">
      <v-btn
        outlined
        class="dark mt-5"
        v-if="!invalid_queue_fetched"
        @click="view_invalid()"
      >
        {{ $t("queue_table_panel.retrospective_button") }}
      </v-btn>
    </div>

    <v-row class="mx-auto" justify="center" v-if="invalid_queue_fetched">
      <v-col cols="12" class="pa-0">
        <h2 class="mt-5 text-center blue-grey--text">
          {{ $t("queue_table_panel.retrospective_list") }}
        </h2>
      </v-col>
      <v-col cols="12" lg="8" class="mb-5 pa-0">
        <v-simple-table dense class="mt-2">
          <template v-slot:default>
            <thead>
              <tr class="blue-grey">
                <th class="text-center white--text font-weight-light">
                  {{ $t("pre_regis_add_subject.subject_id") }}
                </th>
                <th class="text-center white--text font-weight-light">
                  {{ $t("pre_regis_add_subject.subject_name") }}
                </th>
                <th class="text-center white--text font-weight-light">
                  {{ $t("pre_regis_add_subject.section") }}
                </th>
                <th class="text-center white--text font-weight-light">
                  {{ $t("queue_table_panel.status") }}
                </th>
                <th class="text-center white--text font-weight-light last-cell">
                  {{ $t("queue_table_panel.time") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="blue-grey lighten-4"
                v-for="(item, index) in queue_invalid_list"
                :key="index"
              >
                <td class="text-center">{{ item.subject_id }}</td>
                <td class="text-center">
                  <a class="subject-link" @click="openSubjectDialog(item.subject_id)">
                    {{ item.subject_ename }}
                  </a>
                </td>
                <td class="text-center">{{ item.section }}</td>
                <td class="text-center">
                  <!-- ใช้สิทธิ์นี้ในการลงทะเบียนแล้ว -->
                  <span v-if="item.STATUS == '1'">
                    {{
                      $t(
                        "queue_table_panel.this_right_has_been_used_for_registration"
                      )
                    }}
                  </span>
                  <!-- ไม่ได้ใช้สิทธิ์นี้ในการลงทะเบียน -->
                  <span v-if="item.STATUS == '2'">
                    {{
                      $t(
                        "queue_table_panel.this_right_is_not_used_for_registration"
                      )
                    }}
                  </span>
                  <!-- ไม่ได้ใช้สิทธิ์นี้ในการลงทะเบียน -->
                  <span v-if="item.STATUS == '3'">
                    {{
                      $t(
                        "queue_table_panel.this_right_is_not_used_for_registration"
                      )
                    }}
                  </span>
                  <!-- ไม่ได้ใช้สิทธิ์ในระยะเวลาที่กำหนด -->
                  <span v-if="item.STATUS == '4'">
                    {{
                      $t(
                        "queue_table_panel.this_right_is_not_used_in_the_specified_period"
                      )
                    }}
                  </span>
                  <!-- นักศึกษาลบออกจากแถวคอยเอง -->
                  <span v-if="item.STATUS == '5'">
                    {{
                      $t(
                        "queue_table_panel.student_manually_removed_from_the_waiting_list"
                      )
                    }}
                  </span>
                  <!-- ไม่ได้รับสิทธิ์เนื่องจากผิดเงื่อนไข -->
                  <span v-if="item.STATUS == '9'">
                    {{
                      $t(
                        "pre_regis_complete.can_not_register_violate_condition"
                      )
                    }}
                  </span>
                </td>
                <td class="last-cell text-center">
                  <span
                    v-if="item.STATUS !== '9' && item.LAST_ACTION_TIMESTAMP"
                  >
                    {{
                      db_datetime_to_dayjs(item.LAST_ACTION_TIMESTAMP)
                        .locale(lang)
                        .format(`dddd D MMMM ${lang == "th" ? "BBBB" : "YYYY"} HH:mm:ss`)
                    }}
                  </span>
                  <span v-else>-</span>
                </td>
              </tr>
              <tr
                v-if="!queue_invalid_list || queue_invalid_list.length === 0"
                class="blue-grey lighten-4"
              >
                <td class="last-cell text-center" colspan="5">
                  {{ $t("queue_table_panel.no_item") }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-dialog width="500" v-model="remove_queue_dialog" persistent>
      <v-card>
        <v-card-title>
          {{
            $t(
              "queue_table_panel.confirm_the_deletion_of_the_course_from_the_queue"
            )
          }}
        </v-card-title>
        <v-card-text>
          <div style="font-size: 16px; line-height: 1.5em;">
            คุณต้องการลบ
            {{ to_remove_queue ? to_remove_queue.subject_id : "" }}
            ออกจากแถวคอยใช่หรือไม่ หากดำเนินการแล้วจะไม่สามารถยกเลิกได้
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="warning" @click="remove_queue_dialog = false">{{
            $t("pre_regis_add_subject.back")
          }}</v-btn>
          <v-btn dark color="deep-orange" @click="remove_queue()">{{
            $t("pre_regis_add_subject.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <subject-dialog ref="subject_dialog" :level-id="level_id" />
  </div>
</template>

<script>
import { db_datetime_to_dayjs } from "@/helper/dateTime";
import RegistrationProvider from "@/services/registration.provider.js";
import QueueTable from "./QueueTable.vue";
import SubjectDialog from "@/views/teach_table/components/SubjectDialog.vue";
const RegistrationService = new RegistrationProvider();
export default {
  name: "QueueTablePanel",
  components: {
    QueueTable,
    SubjectDialog,
  },
  data: () => ({
    remove_queue_dialog: false,
    to_remove_queue: null,
    loading: false,
  }),
  props: {
    change_period: {
      type: Boolean,
      default: false,
    },
    get_queue_list: {
      type: Function,
    },
    queue_invalid_list: {
      type: Array,
    },
    queue_granted_list: {
      type: Array,
    },
    queued_subject_list: {
      type: Array,
    },
    invalid_queue_fetched: {
      type: Boolean,
    },
    view_invalid: {
      type: Function,
    },
    year: {
      type: String,
    },
    semester: {
      type: String,
    },
    student_id: {
      type: String,
    },
    level_id: {
      type: [String, Number],
      default: 1,
    },
    bypass: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    lang() {
      if (this.$root.$i18n.locale) return this.$root.$i18n.locale;
      return "th";
    },
  },
  methods: {
    openSubjectDialog(subjectId) {
      if (this.$refs.subject_dialog) {
        this.$refs.subject_dialog.show_item_detail(subjectId);
      }
    },
    async remove_queue() {
      this.loading = true;
      const response = await RegistrationService.cancelQueue({
        student_id: this.student_id,
        year: this.year,
        semester: this.semester,
        teach_table_id: this.to_remove_queue.TEACH_TABLE_ID,
        level_id: "1",
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
      });
      if (response && response.status) {
        this.$toasted.success("ลบรายวิชาออกจากแถวคอยสำเร็จ", { duration: 0 });
        await this.get_queue_list(true);
        this.loading = false;
      } else {
        this.$toasted.error("ลบรายวิชาออกจากแถวคอยไม่สำเร็จ", { duration: 0 });
        this.loading = false;
      }
      this.remove_queue_dialog = false;
      this.loading = false;
    },
    open_remove_queue_dialog(item) {
      this.to_remove_queue = item;
      this.remove_queue_dialog = true;
    },
    db_datetime_to_dayjs,
  },
  created() {
    this.get_queue_list();
  },
};
</script>

<style scoped>
td {
  border-width: 0px;
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-color: #ccc;
}
.last-cell {
  border-right-width: 1px;
}

th {
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
}

.full-width {
  overflow: hidden;
  white-space: nowrap;
}

.subject-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  font-weight: inherit;
}

.subject-link:hover {
  text-decoration: none;
}
</style>
